module.exports = __webpack_public_path__ + "img/cash-flow.3006caa8.png";